import React from "react";
import { NavLink } from "react-router-dom";
import Auth from "../../utils/AuthUtils";

function Sidebar() {
  const logOut = () => {
    Auth.logout();
  };

  return (
    <div className="sidebar-account-wrap sidebar-content-wrap sticky-top mb-md-5 mb-3">
      <ul className="my-account-nav">
        <li>
          <NavLink
            to="/users/dashboard"
            className="my-account-nav-item text-sm fw-medium"
          >
            Dashboard
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/users/orders"
            className="my-account-nav-item text-sm fw-medium"
          >
            My Orders
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/users/addresses"
            className="my-account-nav-item text-sm fw-medium"
          >
            Addresses
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/users/account"
            className="my-account-nav-item text-sm fw-medium"
          >
            Account Details
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/users/change-password"
            className="my-account-nav-item text-sm fw-medium"
          >
            Change Password
          </NavLink>
        </li>
        <li>
          <NavLink
            onClick={(e) => logOut()}
            className="my-account-nav-item text-sm fw-medium"
          >
            Logout
          </NavLink>
        </li>
      </ul>
    </div>
  );
}

export default Sidebar;
